import { render, staticRenderFns } from "./ProfileModeration.vue?vue&type=template&id=1fcf5b97&"
import script from "./ProfileModeration.vue?vue&type=script&lang=js&"
export * from "./ProfileModeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports